import { render } from "./WebcamLiveFeed.vue?vue&type=template&id=145b2072&scoped=true&ts=true"
import script from "./WebcamLiveFeed.vue?vue&type=script&lang=ts"
export * from "./WebcamLiveFeed.vue?vue&type=script&lang=ts"

import "./WebcamLiveFeed.vue?vue&type=style&index=0&id=145b2072&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/democratielab-poster/democratielab-poster/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-145b2072"]])

export default __exports__